import React from 'react';
import { numToCurrencyWithLocale } from 'helpers/numToCurrencyWithLocale';
import {
  IAmountsOwedReport,
  IAmountsOwedReportsTableColumnHeading,
} from 'features/amountsOwedReports/amountsOwedReportsTypes';
import { useSelector } from 'react-redux';
import { organizationInfoSelector } from 'features/organization/organizationSlice';

interface TableRowItemProps {
  item: IAmountsOwedReport;
  columns: IAmountsOwedReportsTableColumnHeading[];
}

export const TableRowItem: React.FC<TableRowItemProps> = ({ item, columns }) => {
  const organizationInfo = useSelector(organizationInfoSelector)

  return (
    <>
      <tr>
        {columns.map((col) => {
          if (col.value === 'details') {
            return <></>;
          }
          return (
            <td key={col.value}>
              {col.value === 'amount' || col.value === 'currentRate'
                ? numToCurrencyWithLocale(item[col.value], organizationInfo.currency.code, 'en-US')
                : item[col.value]}
            </td>
          );
        })}
      </tr>
    </>
  );
};

export default TableRowItem;
